const url = "/api/v1/";
import { getToken } from '_services/user-service';

class TimelineReportsService {

  // Get passenger records report
  async getPassengerRecordsReportService(payload, signal) {

    const new_url = url + "cpu/report/passengerRecord";
    const token = await getToken();

    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(new_url, {
          method: "POST",
          headers: {
            'Firebase-UID': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload),
          signal
        });

        let json = await response.json();

        if (response.status >= 400 && response.status < 600) {
          throw new Error('Error getting passenger records report');
        }

        resolve(json);

      } catch (e) {

        //console.log('error', e)

        if (e.name === 'AbortError') {
          reject(new Error('Request was cancelled'));
        } else {
          reject(new Error(e));
        }
      }
    });
  }

  // get passenger breakdown
  async getPassengerBreakdownService(payload, signal) {
    const new_url = url + "cpu/report/passengerBreakdown";
    const token = await getToken();

    //console.log('Fetching Passenger Breakdown with payload:', payload);
    //console.log('url', new_url)

    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(new_url, {
          method: "POST",
          headers: {
            'Firebase-UID': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload),
          signal
        });

        let json = await response.json();

        if (response.status >= 400 && response.status < 600) {
          throw new Error('Error getting passenger breakdown');
        }

        resolve(json);
      } catch (e) {

        //console.log('error', e)

        if (e.name === 'AbortError') {
          reject(new Error('Request was cancelled'));
        } else {
          reject(new Error(e));
        }
      }
    });
  }

  // Get task records report
  async getTaskRecordsReportService(payload, signal) {
    const new_url = url + "cpu/report/taskRecord";
    const token = await getToken();

    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(new_url, {
          method: "POST",
          headers: {
            'Firebase-UID': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload),
          signal
        });

        let json = await response.json();

        if (response.status >= 400 && response.status < 600) {
          throw new Error('Error getting task records report');
        }

        resolve(json);
      } catch (e) {
        if (e.name === 'AbortError') {
          reject(new Error('Request was cancelled'));
        } else {
          reject(new Error(e));
        }
      }
    });
  }

  // Get SLA report
  async getSLAReportService(payload, signal) {
    const new_url = url + "cpu/report/slaReport";
    const token = await getToken();

    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(new_url, {
          method: "POST",
          headers: {
            'Firebase-UID': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload),
          signal
        });

        let json = await response.json();

        if (response.status >= 400 && response.status < 600) {
          throw new Error('Error getting SLA report');
        }

        resolve(json);
      } catch (e) {
        if (e.name === 'AbortError') {
          reject(new Error('Request was cancelled'));
        } else {
          reject(new Error(e));
        }
      }
    });
  }


  // Batch at-loc re-check: run GPS/beacon history on a list of taskIds
  async batchAtLocationCheckService(payload) {
    const new_url = url + "timeline/tasks/batchAtLocationCheck";
    const token = await getToken();
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(new_url, {
          method: "POST",
          headers: {
            'Firebase-UID': token,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload),
        });

        let json = await response.json();

        if (response.status >= 400 && response.status < 600) {
          throw new Error('Error running batch at-loc check');
        }

        resolve(json);
      } catch (e) {
        reject(new Error(e));
      }
    });
  }

}

export default new TimelineReportsService();
